// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isPresent(value: any) {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value === 'number') {
    return true;
  }
  if (typeof value === 'string') {
    return !!value;
  }
  return true;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function allPresent(...values: any[]) {
  return values.every(isPresent);
}

export function presentValues<T>(value: T): Partial<T> {
  const result: Partial<T> = {};
  for (const key in value) {
    if (isPresent(value[key])) {
      result[key] = value[key];
    }
  }
  return result;
}
